;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

// Helper function that takes a duration in seconds and returns a human-readable duration string
// in minutes or combo of hours and minutes, e.g. "1hr 14 min", "50 min"
export const formatDuration = (durationInSeconds: number) => {
  const duration = dayjs.duration(durationInSeconds, 'seconds');
  const durationInHours = duration.hours();
  const durationInMinutes = duration.minutes();
  if (durationInHours > 0) {
    // remainderMinutes is not the total time in minutes, but any leftover after splitting time into hours
    const remainderMinutes = duration
      .subtract({ hours: durationInHours })
      .minutes();
    const hourOrHours = durationInHours > 1 ? 'hours' : 'hour';
    const minuteOrMinutes = remainderMinutes > 1 ? 'minutes' : 'minute';
    return `${durationInHours} ${hourOrHours} ${
      remainderMinutes > 0 ? `${remainderMinutes} ${minuteOrMinutes}` : ''
    }`;
  } else if (durationInMinutes > 0) {
    return `${durationInMinutes} minutes`;
  } else {
    return '';
  }
};
